import { render, staticRenderFns } from "./ModerationForm.vue?vue&type=template&id=8fc7b8a0&scoped=true&"
import script from "./ModerationForm.vue?vue&type=script&lang=js&"
export * from "./ModerationForm.vue?vue&type=script&lang=js&"
import style0 from "./ModerationForm.vue?vue&type=style&index=0&id=8fc7b8a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc7b8a0",
  null
  
)

export default component.exports